import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
/* helpers */
import { httpRequest } from '../../utils/xml-request-helper';
/* components */
import EmptyContent from '../../components/empty-content/empty-content';
import Menu, { MenuItem } from '../../components/menu/menu';
import Modal from '../../components/modal/modal';
import ScrollArea from '../../components/scroll-area/scroll-area';
/* styles */
import './schemes.scss';

function SchemesPage(props) {
    const [isDeleteModalVisible, setDeleteConfirmModal] = useState(false);
    const [deleteSchemeId, setDeleteSchemeId] = useState(null);

    const { model } = props;

    const toggleDeleteConfirmModal = useCallback((flag, id) => {
        setDeleteConfirmModal(flag);
        setDeleteSchemeId(id);
    }, [setDeleteConfirmModal]);

    const handleMenuClick = (type, { id }) => {
        if (type === 'edit') {
            window.location = `/Schemes/Edit/${id}`;
        } else {
            toggleDeleteConfirmModal(true, id);
        }
    };

    const handleSchemeDelete = () => {
        httpRequest({
            method: 'DELETE',
            url: `/Schemes/Delete/${deleteSchemeId}`,
            onSuccess: () => window.location.reload()
        });
    };

    const samlConfig = model.samlServiceConfiguration;

    return (
        <div className="sten-content sten-schemes-page">
            <Modal.Delete
                isOpen={isDeleteModalVisible}
                onDelete={handleSchemeDelete.bind(this)}
                onCancel={toggleDeleteConfirmModal.bind(this, false, null)}
            >
                Are you sure you want to delete this Scheme?
            </Modal.Delete>
            <div className="sten-content__header">
                <h1 className="sten-content__title text-uppercase">Authentication Schemes</h1>
            </div>
            <ScrollArea className="sten-content__body">
                <div className="sten-content__section spread-v--md">
                    <div className="flex-row flex-row--md spread-v--md">
                        <div className="col-md-12 col-xs-24 col-pad--sm">
                            <div className="sten-panel spread-v--md sten-schemes-page__schemes">
                                <div className="sten-panel__header flex">
                                    <div className="flex-grow">
                                        <div className="flex-row flex-center">
                                            <div className="flex-grow">
                                                <h3 className="sten-panel__title">Schemes</h3>
                                            </div>
                                            <div className="flex-shrink">
                                                <a href="/Schemes/Create">
                                                    <span className="btn__icon icon icon-plus" />
                                                    Add Scheme
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sten-panel__body">
                                    {model.schemes && model.schemes.length > 0
                                        ? (
                                            <table className="sten-table sten-table--sm">
                                                <thead>
                                                    <tr>
                                                        <th>Display Name</th>
                                                        <th>Scheme Type</th>
                                                        <th>Enabled</th>
                                                        <th />
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {model.schemes.map(scheme => (
                                                        <tr key={scheme.id}>
                                                            <td>{scheme.displayName}</td>
                                                            <td>{scheme.schemeTypeDescription}</td>
                                                            <td>
                                                                <span
                                                                    className={`sten-badge ${scheme.enabled
                                                                        ? 'sten-badge--success'
                                                                        : 'sten-badge--danger'}`
                                                                    }
                                                                >
                                                                    {scheme.enabled ? 'Yes' : 'No'}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                <Menu>
                                                                    <MenuItem
                                                                        icon="icon-edit"
                                                                        onClick={
                                                                            handleMenuClick.bind(this, 'edit', scheme)
                                                                        }
                                                                    >
                                                                        Edit
                                                                    </MenuItem>
                                                                    <MenuItem
                                                                        icon="icon-delete"
                                                                        onClick={
                                                                            handleMenuClick.bind(this, 'del', scheme)
                                                                        }
                                                                    >
                                                                        Delete
                                                                    </MenuItem>
                                                                </Menu>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )
                                        : (<EmptyContent />)
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-xs-24 col-pad--sm">
                            <div className="sten-panel spread-v--md">
                                <div className="sten-panel__header flex">
                                    <div className="flex-grow">
                                        <div className="flex-row flex-center">
                                            <div className="flex-grow">
                                                <h3 className="sten-panel__title">Saml Tenant Configuration</h3>
                                            </div>
                                            <div className="flex-shrink">
                                                <a href="/Schemes/EditSamlServerConfiguration">
                                                    <span className="btn__icon icon icon-edit" />
                                                    Edit Configuration
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sten-panel__body">
                                    <table className="sten-table sten-table--sm">
                                        <thead>
                                            <tr>
                                                <th>Property</th>
                                                <th>Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Entity Id</td>
                                                <td>{samlConfig ? samlConfig.entityId : '/'}</td>
                                            </tr>
                                            <tr>
                                                <td>Omit Assertion Signature Check</td>
                                                <td>
                                                    {samlConfig ? (
                                                        <span
                                                            className={`sten-badge ${
                                                                samlConfig.omitAssertionSignatureCheck
                                                                    ? 'sten-badge--success'
                                                                    : 'sten-badge--danger'}`
                                                            }
                                                        >
                                                            {samlConfig.omitAssertionSignatureCheck ? 'Yes' : 'No'}
                                                        </span>
                                                    ) : '/'
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Assertion Consumer Service Url
                                                </td>
                                                <td>
                                                    {samlConfig
                                                        ? samlConfig.assertionConsumerServiceUrl
                                                        : 'if not set, use: Saml2/AssertionConsumerService'
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Single Logout Service Url
                                                </td>
                                                <td>
                                                    {samlConfig
                                                        ? samlConfig.singleLogoutServiceUrl
                                                        : 'if not set, use: Saml2/SingleLogoutService'
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Single Logout Response Service Url
                                                </td>
                                                <td>
                                                    {samlConfig
                                                        ? samlConfig.singleLogoutResponseServiceUrl
                                                        : 'if not set, use: Saml2/SingleLogoutService'
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollArea>
        </div>
    );
}

SchemesPage.propTypes = {
    token: PropTypes.string.isRequired,
    model: PropTypes.objectOf(PropTypes.any).isRequired
};

export default SchemesPage;
